/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable import/prefer-default-export */
/**
 * Calculate forecast total value function to calculate forecast total for a date
 */
export const calculateForecastTotalValue = (object) => {
  //
  const forecastTotalList = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(object)) {
    const sum = value.reduce(
      (previousValue, currentValue) => previousValue + currentValue.rate * currentValue.forecast,
      0
    );
    const sumOfForecast = value.reduce(
      (previousValue, currentValue) => previousValue + currentValue.forecast,
      0
    );
    //
    forecastTotalList[key] = {
      forecastTotal: Math.round(sum / sumOfForecast),
    };
  }
  //
  return forecastTotalList;
};
